import { render, staticRenderFns } from "./PurchaseLines.vue?vue&type=template&id=5c0e20e8"
import script from "./PurchaseLines.vue?vue&type=script&lang=js"
export * from "./PurchaseLines.vue?vue&type=script&lang=js"
import style0 from "./PurchaseLines.vue?vue&type=style&index=0&id=5c0e20e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports